module.exports = __webpack_public_path__ + "static/img/led_l_3.da22e78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/led/led_l_3.png
// module id = emQf
// module chunks = 4